export default __webpack_public_path__ + "static/media/tallerartesania.4e341cc0.jpg";